import { useEffect, useState } from "react";
import { getImageUrl } from "../../utils/videoCache";

/**
 * Hook que retorna a URL de uma imagem do cache IndexedDB se disponível,
 * ou a URL original caso contrário. Útil para exibir thumbnails offline.
 */
export const useCachedImageUrl = (url: string | undefined): string => {
	const [cachedUrl, setCachedUrl] = useState<string>(url || "");

	useEffect(() => {
		if (!url) {
			setCachedUrl("");
			return;
		}

		let objectUrl: string | null = null;
		let cancelled = false;

		getImageUrl(url).then((resolved) => {
			// Se retornou um blob URL, guardar para limpar depois
			if (resolved.startsWith("blob:")) {
				objectUrl = resolved;
			}
			if (!cancelled) {
				setCachedUrl(resolved);
			}
		});

		// Cleanup: revogar blob URL quando o componente desmontar
		return () => {
			cancelled = true;
			if (objectUrl) {
				URL.revokeObjectURL(objectUrl);
			}
		};
	}, [url]);

	return cachedUrl;
};
